export default __webpack_public_path__ + "static/media/backers6.9b4a7619.png";